import dayjs from 'dayjs';
import { useEffect, useMemo, useState } from 'react';

function App(props: { startedTime?: number }) {
  const startedTime = props.startedTime;
  const [currentDuration, setCurrentDuration] = useState(0);
  const currentDurationStr = useMemo(() => {
    const oneHour = currentDuration > 60 * 60 * 1000; // 大于1小时: HH:mm:ss
    const formatStr = oneHour ? 'HH:mm:ss' : 'mm:ss';

    return dayjs.duration(currentDuration).format(formatStr);
  }, [currentDuration]);

  useEffect(() => {
    if (startedTime) {
      setCurrentDuration(Date.now() - startedTime); // 先执行一次
      setInterval(() => {
        setCurrentDuration(Date.now() - startedTime);
      }, 1000);
    }
  }, [startedTime]);

  return startedTime ? (
    <div className='flex items-center justify-end font-medium'>
      <span>{dayjs(startedTime).format('MM-DD HH:mm')}</span>
      <span className='mx-2 h-3 w-[1px] overflow-hidden bg-[rgba(19,20,21,.22)]' />
      <span>{currentDurationStr}</span>
    </div>
  ) : (
    <div>
      <span>-</span>
    </div>
  );
}

export default App;
